export default __webpack_public_path__ + "static/media/jayne-monteiro.f308ac7c.svg";